import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { billCategoryModel } from 'app/masters/models/branch-master.model';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-bill-category-master',
  templateUrl: './bill-category-master.component.html',
  styleUrls: ['./bill-category-master.component.scss']
})
export class BillCategoryMasterComponent implements OnInit {
  destroybillCategory$: Subject<boolean> = new Subject<boolean>();
  billCategoryMastermodel: billCategoryModel = {}
  enabledisablebtn: boolean = true;
  private filteredSearchBillcatArray: any = []
  private filteredArray: any[] = [];
  private serviceList: any = [];
  private filterRservicelistArray: Observable<any[]>;
  searchText: string = '';
  reviewServiceId: FormControl;
  constructor(
    private branchmasterService: BranchMatserService,
    private dashboardService: DashboardService,
    private authservice: AuthService,
  ) {
    this.billCategoryMastermodel.isActive = false;
  }

  ngOnInit(): void {
    this.getBillingCategoryMaster(0)
    this.getServiceList();
    this.reviewServiceId = new FormControl();
  }

  enableButton() {
    if ((!this.billCategoryMastermodel.categoryName || this.billCategoryMastermodel.categoryName.toString().trim() === '')
      && (!this.billCategoryMastermodel.categoryCode || this.billCategoryMastermodel.categoryCode.toString().trim() == '')) {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
  }

  getServiceList() {
    this.branchmasterService.getServicemaster(0, this.authservice.Loggeduser.specialityId).pipe(takeUntil(this.destroybillCategory$)).subscribe((res) => {
      this.serviceList = res
      this.reviewSerControll();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  reviewSerControll() {
    this.reviewServiceId = new FormControl();
    this.filterRservicelistArray = this.reviewServiceId.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this.filterRservicefunction(item) : this.serviceList.slice())
      );
  }

  filterRservicefunction(name: string) {
    return this.serviceList.filter(item =>
      item.serviceName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  getreviewObj(e) {
    var val = e.option.id;
    this.billCategoryMastermodel.fK_ServiceID = val
  }

  updateCategoryCode(hex: string): void {
    const hexValue = hex.replace('#', '');
    const r = parseInt(hexValue.substring(0, 2), 16);
    const g = parseInt(hexValue.substring(2, 4), 16);
    const b = parseInt(hexValue.substring(4, 6), 16);
    this.billCategoryMastermodel.categoryCode = `${r}${g}${b}`;
  }

  getBillingCategoryMaster(id) {
    this.branchmasterService.getBillingCategoryMaster(id).pipe(takeUntil(this.destroybillCategory$)).subscribe((res) => {
      this.filteredSearchBillcatArray = res
      this.filteredArray = res
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar("invalid input", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  filterTable() {
    this.filteredArray = this.filteredSearchBillcatArray.filter((item) =>
      Object.keys(item)
        .map((key) => item[key])
        .join(' ')
        .toLowerCase()
        .includes(this.searchText.toLowerCase())
    );
  }


  populatebillCatdata(item: any) {
    if (item) {
      this.billCategoryMastermodel.pK_CategoryId = item.pK_CategoryId;
      this.billCategoryMastermodel.categoryName = item.categoryName;
      this.billCategoryMastermodel.categoryCode = item.categoryCode;
      this.billCategoryMastermodel.consultation = item.serviceName;
      this.billCategoryMastermodel.fresh = item.rate;
      this.billCategoryMastermodel.freeVisit = item.freeVisit
      this.billCategoryMastermodel.freeDays = item.daysLimit
      this.billCategoryMastermodel.isActive = item.isActive;
      this.billCategoryMastermodel.webColor = item.webColor;
      this.billCategoryMastermodel.fK_ServiceID = item.fK_ServiceID;

    }
    if ((!this.billCategoryMastermodel.categoryName || this.billCategoryMastermodel.categoryName.toString().trim() === '')
      && (!this.billCategoryMastermodel.categoryCode || this.billCategoryMastermodel.categoryCode.toString().trim() == '')) {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
    this.closebillcategoryModal();
  }



  insertBillingCategoryMasters(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);

    if (!this.billCategoryMastermodel.categoryName) {
      this.dashboardService.openSnackBar(" Please Select Category Name", "OK");
      return;
    }
    if (!this.billCategoryMastermodel.categoryCode) {
      this.dashboardService.openSnackBar(" Please Select Color Code", "OK");
      return;
    }

    const isValidServiceInput = this.billCategoryMastermodel.consultation?.trim();
    if (isValidServiceInput) {
      const isValidService = this.serviceList.some(service => service.serviceName.toLowerCase() == isValidServiceInput.toLowerCase());
      if (!isValidService) {
        this.dashboardService.openSnackBar("Please select a valid Consultation service", "OK");
        return;
      }
    }

    const insertCategoryMasterDto = {
      "pK_CategoryId": this.billCategoryMastermodel.pK_CategoryId ? this.billCategoryMastermodel.pK_CategoryId : 0,
      "categoryName": this.billCategoryMastermodel.categoryName,
      "categoryCode": this.billCategoryMastermodel.categoryCode,
      "isActive": this.billCategoryMastermodel.isActive,
      "fK_ServiceID": this.billCategoryMastermodel.fK_ServiceID ? this.billCategoryMastermodel.fK_ServiceID : null,
      "rate": this.billCategoryMastermodel.fresh,
      "daysLimit": this.billCategoryMastermodel.freeDays,
      "freeVisit": this.billCategoryMastermodel.freeVisit,
      "webColor": this.billCategoryMastermodel.webColor,
      "isEmmergency": null,
      "fk_SpecialityIdModule": this.authservice.Loggeduser.specialityId,
      "IsEdit": this.billCategoryMastermodel.pK_CategoryId ? true : false
    }

    let payload = { BillingCategoryMasterDto: insertCategoryMasterDto }

    this.branchmasterService.insertBillingCategoryMasters(payload).pipe(takeUntil(this.destroybillCategory$)).subscribe((x) => {
      if (x['statusCode'] == 10) { this.clear(); this.dashboardService.openSnackBar("This record is already exists", "OK"); }
      if (x['statusCode'] == 1) {
        this.getBillingCategoryMaster(0);
        this.dashboardService.openSnackBar(insertCategoryMasterDto.pK_CategoryId == 0 ? "Record Saved Successfully" : "Record Updated Successfully", "OK");
        this.clear();
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }

  clear() {
    this.billCategoryMastermodel.categoryName = null;
    this.billCategoryMastermodel.categoryCode = null;
    this.billCategoryMastermodel.consultation = null;
    this.billCategoryMastermodel.fresh = null;
    this.billCategoryMastermodel.freeVisit = null;
    this.billCategoryMastermodel.freeDays = null;
    this.billCategoryMastermodel.isActive = false;
    this.billCategoryMastermodel.webColor = "";
    this.billCategoryMastermodel.pK_CategoryId = null;
    this.billCategoryMastermodel.fK_ServiceID = null
    this.enabledisablebtn = true;
  }

  openbillcategoryModal() {
    this.searchText = '';
    this.getBillingCategoryMaster(0);
    document.getElementById("billcategoryModal").style.display = 'block';
  }

  closebillcategoryModal() {
    document.getElementById("billcategoryModal").style.display = 'none';
  }

  ngOnDestroy() {
    this.destroybillCategory$.next(true);
    this.destroybillCategory$.unsubscribe();
    this.filteredSearchBillcatArray = null;
    this.filteredArray = null;
    this.serviceList = null;
    this.filterRservicelistArray = null;
  }
}
